import { render } from "./ViewGuide.vue?vue&type=template&id=5bd08082&scoped=true"
import script from "./ViewGuide.vue?vue&type=script&lang=js"
export * from "./ViewGuide.vue?vue&type=script&lang=js"

import "./ViewGuide.vue?vue&type=style&index=0&id=5bd08082&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bd08082"]])

export default __exports__